import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';

let { 
  BASE_FONT_COLOR, 
  MODAL_BACKGROUND_COLOR, 
  RESIZE_HANDLER_COLOR, 
  TABLE_SELECTED_COLOR,
  TABLE_BG_COLOR,
  TABLE_TEXT_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    flexFlow: 'column',
    height: 'calc(100% - 60px)'
  },
  show: {
    position: 'relative',
  },
  mapDiv:{
    position: 'relative',
    height: '50%',
    flex: '1 1 auto',
    boxSizing: 'border-box'
  },
  list:{
    position: 'relative',
    boxSizing: 'border-box',
    flex: '1 1 0'
  },
  hide: {
    display: 'none'
  },
  map: {
    width: '100%',
    height: '100%'
  },
  nohistory:{
    position: 'absolute',
    zIndex: 1,
    border: '2px solid #333',
    top: '50%',
    left: '40%',
    backgroundColor: MODAL_BACKGROUND_COLOR,
    color: BASE_FONT_COLOR,
    borderRadius: 5,
    textAlign: 'center',
    padding: 5
  },
  resizeHandle: {
    position: 'absolute',
    left: '45%',
    height: '15px',
    borderRadius: '3px 3px 0 0',
    width: '100px',
    backgroundColor: RESIZE_HANDLER_COLOR,
    cursor: 'row-resize',
    bottom: '0px',
    zIndex: 1,
    color: '#fff',
    textAlign: 'center'
  },
  bar: {
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    alignItems: 'center',
    height: 30,
    width: '100%',
    backgroundColor: TABLE_SELECTED_COLOR,
    color: TABLE_TEXT_COLOR,
    borderBottom: `1px solid ${TABLE_BG_COLOR}`
  },
  addButton: {
    position: 'absolute',
    right: 30,
    bottom: 30
  },
  editList: {
    width: '100%'
  },
  searchBase: {
    margin: '4px auto -15px auto',
    width: '95%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/home/Home.styles.js